import { render, staticRenderFns } from "./ArticlePicture.vue?vue&type=template&id=0d1932f8&scoped=true&"
import script from "./ArticlePicture.vue?vue&type=script&lang=js&"
export * from "./ArticlePicture.vue?vue&type=script&lang=js&"
import style0 from "./ArticlePicture.vue?vue&type=style&index=0&id=0d1932f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d1932f8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d1932f8')) {
      api.createRecord('0d1932f8', component.options)
    } else {
      api.reload('0d1932f8', component.options)
    }
    module.hot.accept("./ArticlePicture.vue?vue&type=template&id=0d1932f8&scoped=true&", function () {
      api.rerender('0d1932f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/staff-engagement/components/ArticlePicture.vue"
export default component.exports